import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { Booking, Vacation } from '@thro-types/leihbar';

import { endOfDay, isWithinInterval, startOfDay } from 'date-fns';

import { Colors } from 'utils/colors';

interface VacationPickersDayProps {
  day: Date;
  pickersDayProps: PickersDayProps<Date>;
  vacations: Vacation[];
  bookings: Booking[] | undefined;
}

export const VacationPickersDay = ({
  day,
  pickersDayProps,
  vacations,
  bookings
}: VacationPickersDayProps) => {
  const getBackgroundColor = () => {
    if (pickersDayProps.disabled || vacations.length === 0) {
      return undefined;
    }

    const isVacationOverlap = vacations.some(vacation =>
      isWithinInterval(day, {
        start: startOfDay(new Date(vacation.startDate)),
        end: endOfDay(new Date(vacation.endDate))
      })
    );

    const isBookingOverlap =
      bookings &&
      bookings.some(booking =>
        isWithinInterval(day, {
          start: startOfDay(new Date(booking.startTime)),
          end: endOfDay(new Date(booking.endTime))
        })
      );

    if (isVacationOverlap && isBookingOverlap) {
      return Colors.vacationAndBookingColor;
    } else if (isVacationOverlap) {
      return Colors.vacationColor;
    } else if (isBookingOverlap) {
      return Colors.vacationConflictBookingColor;
    }
  };

  const { key, ...props } = pickersDayProps;

  return (
    <PickersDay
      {...props}
      day={day}
      style={
        pickersDayProps.disabled
          ? { background: getBackgroundColor() }
          : { background: getBackgroundColor(), fontWeight: 550 }
      }
    />
  );
};
